<template>
  <el-card style="margin-top: 20px">
    <div  class="title" >
      <p class="title1">考试安排表</p>
      <p style="margin-bottom: 10px">
        <span>学号:{{userInfo.student_id}}</span>
        <span style="margin-left: 10px">姓名:{{userInfo.name}}</span>
      </p>
    </div>
    <div style="margin-bottom: 10px">
      <TermSelect v-model="term"></TermSelect>
      <el-button type="success" style="margin-left: 10px" @click="loadData">查询学期</el-button>
    </div>
    <el-table
        :data="tableData"
        style="width: 100%"
        row-key="id"
        size="mini"
        v-loading="loading"
        border
        lazy
        :tree-props="{ children: 'children', hasChildren: 'sublayer' }"
        :header-cell-style="{ background: '#f7f2f2', color: '#606266' }"
    >
      <el-table-column prop="term" label="学期"  align="center" width="200" />
      <el-table-column prop="type_name" label="考试类型"  align="center" width="100" />
      <el-table-column prop="datetime_name" label="场次名称"  align="center" width="100" />
      <el-table-column prop="course_content" label="课程名称"  align="center" width="200" />
      <el-table-column prop="begin_date_time" label="开始时间"  align="center" width="170" />
      <el-table-column prop="end_date_time" label="结束时间"  align="center" width="170" />
      <el-table-column prop="exam_place" label="地点" align="center"></el-table-column>
    </el-table>
    </el-card>

</template>
<script setup>
import {ref} from "vue";
import {getStudentAvgMark,} from "../../../api/mine";
import {queryExaminationArrangement} from "../../../api/Learn-traces";
import TermSelect from "@/component/TermSelect.vue";

const tableData = ref([])
const term=ref("")
const loading = ref(false);
const loadData = () => {
  loading.value = true;
  queryExaminationArrangement({term:term.value}).then(data=>{
    tableData.value = data.datas.data;
    loading.value = false;
  })
}
loadData()
const userInfo = ref({})
getStudentAvgMark().then(data=>{
  userInfo.value=data.datas
})

</script>
<style lang="scss" scoped>
.title{
  text-align: center;
  .title1{
    font-size: 20px;
    line-height: 50px;
  }
}

</style>

